import { render, staticRenderFns } from "./Recover.vue?vue&type=template&id=669c876e&scoped=true&"
import script from "./Recover.vue?vue&type=script&lang=js&"
export * from "./Recover.vue?vue&type=script&lang=js&"
import style0 from "./Recover.vue?vue&type=style&index=0&id=669c876e&lang=less&scoped=true&"
import style1 from "./Recover.vue?vue&type=style&index=1&id=669c876e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669c876e",
  null
  
)

export default component.exports